
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRouterComponent as ObiRouterComponentElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-router-component.js';
 
 
 

 
 export const ObiRouterComponent = createComponent({
   react: React,
   tagName: 'obi-router-component',
   elementClass: ObiRouterComponentElement,
   events: {
     
   }
  });
 
 